import styled from 'styled-components';
import { Card, Skeleton } from '@mui/material';
import { Error } from '@material-ui/icons';
import five from '../../../assets/media/aden/teamwork-high-five-1.png';

export const GuestContact = ({ contact, code, loading, error }) => {
    if (loading) {
        return (
            <GuestContactWrapper>
                <SkeletonInviteLabel>
                    <Skeleton variant="text" width={80} height={24} />
                </SkeletonInviteLabel>
                <GuestContactContent>
                    <ContentWrapper>
                        <Skeleton variant="circular" width={100} height={100} />
                        <SkeletonInfo>
                            <Skeleton variant="text" width={200} height={24} />
                            <Skeleton variant="text" width={150} height={24} />
                        </SkeletonInfo>
                    </ContentWrapper>
                </GuestContactContent>
            </GuestContactWrapper>
        );
    }

    if (error) {
        return (
            <GuestContactWrapper>
                <ErrorContainer>
                    <Error style={{ fontSize: '48px', color: '#B31D15' }} />
                    <ErrorText>Ha ocurrido un error</ErrorText>
                    <ErrorSubText>
                        No se pudo cargar la información del contacto
                    </ErrorSubText>
                </ErrorContainer>
            </GuestContactWrapper>
        );
    }

    return (
        <GuestContactWrapper>
            <InviteLabel>Te invitó:</InviteLabel>
            <GuestContactContent>
                <ContentWrapper>
                    <Image>
                        <img
                            alt="user"
                            src={
                                contact?.photo ||
                                'https://www.aden.org/images/default_avatar.png'
                            }
                        />
                    </Image>
                    <GuestContactInfo>
                        <label>
                            Nombre: <b>{contact?.name}</b>
                        </label>
                        <label>
                            N° de legajo: <b className="code-red">{code}</b>
                        </label>
                    </GuestContactInfo>
                </ContentWrapper>
                <FiveImage src={five} />
            </GuestContactContent>
        </GuestContactWrapper>
    );
};

const GuestContactWrapper = styled(Card)`
    background-color: #ffffff;
    box-shadow:
        0px 3px 6px 0px #0000003b,
        0px 3px 6px 0px #00000029;
    border-radius: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #a8a8a8;
    box-sizing: border-box;
    position: relative;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }

    @media (max-width: 480px) {
        padding: 1rem;
    }
`;

const InviteLabel = styled.p`
    position: absolute;
    top: 1rem;
    left: 2.7rem;
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    font-style: italic;
    color: #b31d15;
    text-align: center;
    z-index: 1;

    @media (max-width: 768px) {
        top: 1.5rem;
        left: 4rem;
    }

    @media (max-width: 640px) {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        margin-bottom: 0.5rem;
    }
`;

const GuestContactContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    position: relative;

    @media (max-width: 640px) {
        flex-direction: column;
        align-items: center;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 3.5rem 2rem 1.5rem 2rem;

    @media (max-width: 640px) {
        flex-direction: column;
        text-align: center;
        padding: 1.5rem;
    }
`;

const GuestContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;

    label {
        font-size: 16px;
        font-weight: 400;
        color: #222222;
    }

    .code-red {
        color: #b31d15;
        font-weight: 700;
    }

    @media (max-width: 640px) {
        align-items: center;
    }
`;

const Image = styled.div`
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    border-radius: 100%;
    border: 5px solid #b31d15;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 100%;
    }

    @media (max-width: 640px) {
        width: 100px;
        height: 100px;
    }
`;

const FiveImage = styled.img`
    position: absolute;
    right: 2rem;
    top: 0;
    bottom: 0;
    height: 100%;
    width: auto;
    object-fit: contain;

    @media (max-width: 768px) {
        right: 1.5rem;
    }

    @media (max-width: 640px) {
        position: relative;
        right: auto;
        height: auto;
        max-height: 100px;
        margin-top: 1rem;
    }
`;

const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 2rem;
    width: 100%;
`;

const ErrorText = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: #b31d15;
    text-align: center;
`;

const ErrorSubText = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: #666;
    text-align: center;
`;

const SkeletonInviteLabel = styled.div`
    position: absolute;
    top: 1rem;
    left: 2.7rem;
    z-index: 1;

    @media (max-width: 768px) {
        top: 1.5rem;
        left: 4rem;
    }

    @media (max-width: 640px) {
        position: relative;
        top: auto;
        left: auto;
        margin-bottom: 0.5rem;
        display: flex;
        justify-content: center;
    }
`;

const SkeletonInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;

    @media (max-width: 640px) {
        align-items: center;
    }
`;
